import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Presentation from "./pages/Presentation";
import Tournee from "./pages/Tournee";
import Merch from "./pages/Merch";
import Prestations from "./pages/Prestations";
import PrestationsEvenements from "./pages/PrestationsEvenements";
import PrestationsPhotos from "./pages/PrestationsPhotos";
import PrestationsVideos from "./pages/PrestationsVideos";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App bg-black text-neutral-100 min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/presentation" element={<Presentation />} />
            <Route path="/tournee" element={<Tournee />} />
            <Route path="/merch" element={<Merch />} />
            <Route path="/prestations" element={<Prestations />} />
            <Route path="/prestations/evenements" element={<PrestationsEvenements />} />
            <Route path="/prestations/photos" element={<PrestationsPhotos />} />
            <Route path="/prestations/videos" element={<PrestationsVideos />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
